import Background_Attachment from "./CSS_component/Background_Attachment";
import Background_Clip from "./CSS_component/Background_Clip";

import Background_Image from "./CSS_component/Background_Image";
import Background_Origin from "./CSS_component/Background_Origin";
import Background_Repeat from "./CSS_component/Background_Repeat";
import Background_Shorthand from "./CSS_component/Background_Shorthand";
import Background_Size from "./CSS_component/Background_Size";
import Border_Color from "./CSS_component/Border_Color";
import Border_Rounded from "./CSS_component/Border_Rounded";
import Border_Shorthand from "./CSS_component/Border_Shorthand";
import Border_Sides from "./CSS_component/Border_Sides";
import Border_Width from "./CSS_component/Border_Width";
import Box_Shadow from "./CSS_component/Box_Shadow";
import Change_Variables_With_JavaScript from "./CSS_component/Change_Variables_With_JavaScript";
import Clear from "./CSS_component/Clear";
import Conic_Gradients from "./CSS_component/Conic_Gradients";
import CSS_2DTransforms from "./CSS_component/CSS_2DTransforms";
import CSS_3DTransforms from "./CSS_component/CSS_3DTransforms";
import CSS_Accessibility from "./CSS_component/CSS_Accessibility";
import CSS_Align from "./CSS_component/CSS_Align";
import CSS_Animations from "./CSS_component/CSS_Animations";
import CSS_AtSupports from "./CSS_component/CSS_AtSupports";
import CSS_AttrSelectors from "./CSS_component/CSS_AttrSelectors";
import CSS_Backgrounds from "./CSS_component/CSS_Backgrounds";
import CSS_BackgroundsAdvanced from "./CSS_component/CSS_BackgroundsAdvanced";
import CSS_Bootcamp from "./CSS_component/CSS_Bootcamp";
import CSS_BorderImages from "./CSS_component/CSS_BorderImages";
import CSS_Borders from "./CSS_component/CSS_Borders";
import CSS_BoxModel from "./CSS_component/CSS_BoxModel";
import CSS_BoxSizing from "./CSS_component/CSS_BoxSizing";
import CSS_Buttons from "./CSS_component/CSS_Buttons";
import CSS_Certificate from "./CSS_component/CSS_Certificate";
import CSS_ColorKeywords from "./CSS_component/CSS_ColorKeywords";
import CSS_Colors from "./CSS_component/CSS_Colors";
import CSS_ColorsAdvanced from "./CSS_component/CSS_ColorsAdvanced";
import CSS_Combinators from "./CSS_component/CSS_Combinators";
import CSS_Comments from "./CSS_component/CSS_Comments";
import CSS_Counters from "./CSS_component/CSS_Counters";
import CSS_Display from "./CSS_component/CSS_Display";
import CSS_Dropdowns from "./CSS_component/CSS_Dropdowns";
import CSS_Editor from "./CSS_component/CSS_Editor";
import CSS_Errors from "./CSS_component/CSS_Errors";
import CSS_Examples from "./CSS_component/CSS_Examples";
import CSS_Exercises from "./CSS_component/CSS_Exercises";
import CSS_Float from "./CSS_component/CSS_Float";
import CSS_Fonts from "./CSS_component/CSS_Fonts";
import CSS_Forms from "./CSS_component/CSS_Forms";
import CSS_Gradients from "./CSS_component/CSS_Gradients";
import CSS_HeightWidth from "./CSS_component/CSS_HeightWidth";
import CSS_HEX from "./CSS_component/CSS_HEX";
import CSS_Home from "./CSS_component/CSS_Home";
import CSS_HowTo from "./CSS_component/CSS_HowTo";
import CSS_HSL from "./CSS_component/CSS_HSL";
import CSS_Icons from "./CSS_component/CSS_Icons";
import CSS_ImageCentering from "./CSS_component/CSS_ImageCentering";
import CSS_ImageFilters from "./CSS_component/CSS_ImageFilters";
import CSS_ImageGallery from "./CSS_component/CSS_ImageGallery";
import CSS_ImageShapes from "./CSS_component/CSS_ImageShapes";
import CSS_ImageSprites from "./CSS_component/CSS_ImageSprites";
import CSS_ImageStyling from "./CSS_component/CSS_ImageStyling";
import CSS_Important from "./CSS_component/CSS_Important";
import CSS_InlineBlock from "./CSS_component/CSS_InlineBlock";
import CSS_InterviewPrep from "./CSS_component/CSS_InterviewPrep";
import CSS_Introduction from "./CSS_component/CSS_Introduction";
import CSS_Links from "./CSS_component/CSS_Links";
import CSS_Lists from "./CSS_component/CSS_Lists";
import CSS_Margins from "./CSS_component/CSS_Margins";
import CSS_Masking from "./CSS_component/CSS_Masking";
import CSS_MathFunctions from "./CSS_component/CSS_MathFunctions";
import CSS_MaxWidth from "./CSS_component/CSS_MaxWidth";
import CSS_MediaQueries from "./CSS_component/CSS_MediaQueries";
import CSS_MQExamples from "./CSS_component/CSS_MQExamples";
import CSS_MultipleColumns from "./CSS_component/CSS_MultipleColumns";
import CSS_NavigationBars from "./CSS_component/CSS_NavigationBars";
import CSS_ObjectFit from "./CSS_component/CSS_ObjectFit";
import CSS_ObjectPosition from "./CSS_component/CSS_ObjectPosition";
import CSS_Opacity from "./CSS_component/CSS_Opacity";
import CSS_Outline from "./CSS_component/CSS_Outline";
import CSS_Overflow from "./CSS_component/CSS_Overflow";
import CSS_Padding from "./CSS_component/CSS_Padding";
import CSS_Pagination from "./CSS_component/CSS_Pagination";
import CSS_Performance from "./CSS_component/CSS_Performance";
import CSS_Position from "./CSS_component/CSS_Position";
import CSS_Property from "./CSS_component/CSS_Property";
import CSS_PseudoClasses from "./CSS_component/CSS_PseudoClasses";
import CSS_PseudoElements from "./CSS_component/CSS_PseudoElements";
import CSS_PXEMConverter from "./CSS_component/CSS_PXEMConverter";
import CSS_Quiz from "./CSS_component/CSS_Quiz";
import CSS_Reference from "./CSS_component/CSS_Reference";
import CSS_ReferenceAnimatable from "./CSS_component/CSS_ReferenceAnimatable";
import CSS_ReferenceAtRules from "./CSS_component/CSS_ReferenceAtRules";
import CSS_ReferenceAural from "./CSS_component/CSS_ReferenceAural";
import CSS_ReferenceBrowserSupport from "./CSS_component/CSS_ReferenceBrowserSupport";
import CSS_ReferenceColors from "./CSS_component/CSS_ReferenceColors";
import CSS_ReferenceColorValues from "./CSS_component/CSS_ReferenceColorValues";
import CSS_ReferenceCombinators from "./CSS_component/CSS_ReferenceCombinators";
import CSS_ReferenceDefaultValues from "./CSS_component/CSS_ReferenceDefaultValues";
import CSS_ReferenceFunctions from "./CSS_component/CSS_ReferenceFunctions";
import CSS_ReferencePseudoClasses from "./CSS_component/CSS_ReferencePseudoClasses";
import CSS_ReferencePseudoElements from "./CSS_component/CSS_ReferencePseudoElements";
import CSS_ReferenceSelectors from "./CSS_component/CSS_ReferenceSelectors";
import CSS_ReferenceUnits from "./CSS_component/CSS_ReferenceUnits";
import CSS_ReferenceWebSafeFonts from "./CSS_component/CSS_ReferenceWebSafeFonts";
import CSS_RGB from "./CSS_component/CSS_RGB";
import CSS_RoundedCorners from "./CSS_component/CSS_RoundedCorners";
import CSS_Selectors from "./CSS_component/CSS_Selectors";
import CSS_Shadows from "./CSS_component/CSS_Shadows";
import CSS_Snippets from "./CSS_component/CSS_Snippets";
import CSS_Specificity from "./CSS_component/CSS_Specificity";
import CSS_StudyPlan from "./CSS_component/CSS_StudyPlan";
import CSS_Syllabus from "./CSS_component/CSS_Syllabus";
import CSS_Syntax from "./CSS_component/CSS_Syntax";
import CSS_Tables from "./CSS_component/CSS_Tables";
import CSS_Templates from "./CSS_component/CSS_Templates";
import CSS_Text from "./CSS_component/CSS_Text";
import CSS_TextEffects from "./CSS_component/CSS_TextEffects";
import CSS_Tooltips from "./CSS_component/CSS_Tooltips";
import CSS_Transitions from "./CSS_component/CSS_Transitions";
import CSS_Units from "./CSS_component/CSS_Units";
import CSS_UserInterface from "./CSS_component/CSS_UserInterface";
import CSS_Variables from "./CSS_component/CSS_Variables";
import CSS_WebFonts from "./CSS_component/CSS_WebFonts";
import CSS_Website from "./CSS_component/CSS_Website";
import CSS_WebsiteLayout from "./CSS_component/CSS_WebsiteLayout";
import CSS_ZIndex from "./CSS_component/CSS_ZIndex";
import Flexbox_Intro from "./CSS_component/Flexbox_Intro";
import Flex_Container from "./CSS_component/Flex_Container";
import Flex_Items from "./CSS_component/Flex_Items";
import Flex_Responsive from "./CSS_component/Flex_Responsive";
import Fonts_Google from "./CSS_component/Fonts_Google";
import Fonts_Pairings from "./CSS_component/Fonts_Pairings";
import Fonts_Shorthand_Property from "./CSS_component/Fonts_Shorthand_Property";
import Font_Fallbacks from "./CSS_component/Font_Fallbacks";
import Font_Size from "./CSS_component/Font_Size";
import Font_Style from "./CSS_component/Font_Style";
import Grid_ColumnsRows from "./CSS_component/Grid_ColumnsRows";
import Grid_Container from "./CSS_component/Grid_Container";
import Grid_Intro from "./CSS_component/Grid_Intro";
import Grid_Item from "./CSS_component/Grid_Item";
import Grid_Lines from "./CSS_component/Grid_Lines";
import Horizontal_Navigation_Bar from "./CSS_component/Horizontal_Navigation_Bar";
import Outline_Color from "./CSS_component/Outline_Color";
import Outline_Offset from "./CSS_component/Outline_Offset";
import Outline_Shorthand from "./CSS_component/Outline_Shorthand";
import Outline_Width from "./CSS_component/Outline_Width";
import Overriding_Variables from "./CSS_component/Overriding_Variables";
import Radial_Gradients from "./CSS_component/Radial_Gradients";
import RWD_Frameworks from "./CSS_component/RWD_Frameworks";
import RWD_GridView from "./CSS_component/RWD_GridView";
import RWD_Images from "./CSS_component/RWD_Images";
import RWD_Intro from "./CSS_component/RWD_Intro";
import RWD_MediaQueries from "./CSS_component/RWD_MediaQueries";
import RWD_Templates from "./CSS_component/RWD_Templates";
import RWD_Videos from "./CSS_component/RWD_Videos";
import RWD_Viewport from "./CSS_component/RWD_Viewport";
import SASS_Tutorial from "./CSS_component/SASS_Tutorial";
import Tables_Responsive from "./CSS_component/Tables_Responsive";
import Table_Alignment from "./CSS_component/Table_Alignment";
import Table_Collapse from "./CSS_component/Table_Collapse";
import Table_Borders from "./CSS_component/Table_Borders";
import Table_Size from "./CSS_component/Table_Size";
import Table_Styling from "./CSS_component/Table_Styling";
import Text_Alignment from "./CSS_component/Text_Alignment";
import Text_Color from "./CSS_component/Text_Color";
import Text_Decoration from "./CSS_component/Text_Decoration";
import Text_Shadow from "./CSS_component/Text_Shadow";
import Text_Spacing from "./CSS_component/Text_Spacing";
import Text_Transformation from "./CSS_component/Text_Transformation";
import Variables_in_Media_Queries from "./CSS_component/Variables_in_Media_Queries";
import Vertical_Navigation_Bar from "./CSS_component/Vertical_Navigation_Bar";
import Web_Safe_Fonts from "./CSS_component/Web_Safe_Fonts";
import CSS_Fonts_Family from "./CSS_component/CSS_Fonts_Family";
import CSS_Ordered_List from "./CSS_component/CSS_Ordered_List";
import CSS_Unordered_List from "./CSS_component/CSS_Unordered_List";
import CSS_Description_List from "./CSS_component/CSS_Description_List";
import CSS_ReferenceEntittes from "./CSS_component/CSS_ReferenceEntittes";
const AllCssComponents = {
  "<Background_Attachment />": Background_Attachment,
  "<CSS_Ordered_List />": CSS_Ordered_List,
  "<CSS_Unordered_List />": CSS_Unordered_List,
  "<CSS_Description_List />": CSS_Description_List,
  "<Background_Clip />": Background_Clip,
  "<CSS_Fonts_Family />": CSS_Fonts_Family,
  "<Table_Collapse />": Table_Collapse,

  "<Background_Image />": Background_Image,
  "<Background_Origin />": Background_Origin,
  "<Background_Repeat />": Background_Repeat,
  "<Background_Shorthand />": Background_Shorthand,
  "<Background_Size />": Background_Size,
  "<Border_Color />": Border_Color,
  "<Border_Rounded />": Border_Rounded,
  "<Border_Shorthand />": Border_Shorthand,
  "<Border_Sides />": Border_Sides,
  "<Border_Width />": Border_Width,
  "<Box_Shadow />": Box_Shadow,
  "<CSS_ReferenceEntittes />": CSS_ReferenceEntittes,
  "<Change_Variables_With_JavaScript />": Change_Variables_With_JavaScript,
  "<Clear />": Clear,
  "<Conic_Gradients />": Conic_Gradients,
  "<CSS_2DTransforms />": CSS_2DTransforms,
  "<CSS_3DTransforms />": CSS_3DTransforms,
  "<CSS_Accessibility />": CSS_Accessibility,
  "<CSS_Align />": CSS_Align,
  "<CSS_Animations />": CSS_Animations,
  "<CSS_AtSupports />": CSS_AtSupports,
  "<CSS_AttrSelectors />": CSS_AttrSelectors,
  "<CSS_Backgrounds />": CSS_Backgrounds,
  "<CSS_BackgroundsAdvanced />": CSS_BackgroundsAdvanced,
  "<CSS_Bootcamp />": CSS_Bootcamp,
  "<CSS_BorderImages />": CSS_BorderImages,
  "<CSS_Borders />": CSS_Borders,
  "<CSS_BoxModel />": CSS_BoxModel,
  "<CSS_BoxSizing />": CSS_BoxSizing,
  "<CSS_Buttons />": CSS_Buttons,
  "<CSS_Certificate />": CSS_Certificate,
  "<CSS_ColorKeywords />": CSS_ColorKeywords,
  "<CSS_Colors />": CSS_Colors,
  "<CSS_ColorsAdvanced />": CSS_ColorsAdvanced,
  "<CSS_Combinators />": CSS_Combinators,
  "<CSS_Comments />": CSS_Comments,
  "<CSS_Counters />": CSS_Counters,
  "<CSS_Display />": CSS_Display,
  "<CSS_Dropdowns />": CSS_Dropdowns,
  "<CSS_Editor />": CSS_Editor,
  "<CSS_Errors />": CSS_Errors,
  "<CSS_Examples />": CSS_Examples,
  "<CSS_Exercises />": CSS_Exercises,
  "<CSS_Float />": CSS_Float,
  "<CSS_Fonts />": CSS_Fonts,
  "<CSS_Forms />": CSS_Forms,
  "<CSS_Gradients />": CSS_Gradients,
  "<CSS_HeightWidth />": CSS_HeightWidth,
  "<CSS_HEX />": CSS_HEX,
  "<CSS_Home />": CSS_Home,
  "<CSS_HowTo />": CSS_HowTo,
  "<CSS_HSL />": CSS_HSL,
  "<CSS_Icons />": CSS_Icons,
  "<CSS_ImageCentering />": CSS_ImageCentering,
  "<CSS_ImageFilters />": CSS_ImageFilters,
  "<CSS_ImageGallery />": CSS_ImageGallery,
  "<CSS_ImageShapes />": CSS_ImageShapes,
  "<CSS_ImageSprites />": CSS_ImageSprites,
  "<CSS_ImageStyling />": CSS_ImageStyling,
  "<CSS_Important />": CSS_Important,
  "<CSS_InlineBlock />": CSS_InlineBlock,
  "<CSS_InterviewPrep />": CSS_InterviewPrep,
  "<CSS_Introduction />": CSS_Introduction,
  "<CSS_Links />": CSS_Links,
  "<CSS_Lists />": CSS_Lists,
  "<CSS_Margins />": CSS_Margins,
  "<CSS_Masking />": CSS_Masking,
  "<CSS_MathFunctions />": CSS_MathFunctions,
  "<CSS_MaxWidth />": CSS_MaxWidth,
  "<CSS_MediaQueries />": CSS_MediaQueries,
  "<CSS_MQExamples />": CSS_MQExamples,
  "<CSS_MultipleColumns />": CSS_MultipleColumns,
  "<CSS_NavigationBars />": CSS_NavigationBars,
  "<CSS_ObjectFit />": CSS_ObjectFit,
  "<CSS_ObjectPosition />": CSS_ObjectPosition,
  "<CSS_Opacity />": CSS_Opacity,
  "<CSS_Outline />": CSS_Outline,
  "<CSS_Overflow />": CSS_Overflow,
  "<CSS_Padding />": CSS_Padding,
  "<CSS_Pagination />": CSS_Pagination,
  "<CSS_Performance />": CSS_Performance,
  "<CSS_Position />": CSS_Position,
  "<CSS_Property />": CSS_Property,
  "<CSS_PseudoClasses />": CSS_PseudoClasses,
  "<CSS_PseudoElements />": CSS_PseudoElements,
  "<CSS_PXEMConverter />": CSS_PXEMConverter,
  "<CSS_Quiz />": CSS_Quiz,
  "<CSS_Reference />": CSS_Reference,
  "<CSS_ReferenceAnimatable />": CSS_ReferenceAnimatable,
  "<CSS_ReferenceAtRules />": CSS_ReferenceAtRules,
  "<CSS_ReferenceAural />": CSS_ReferenceAural,
  "<CSS_ReferenceBrowserSupport />": CSS_ReferenceBrowserSupport,
  "<CSS_ReferenceColors />": CSS_ReferenceColors,
  "<CSS_ReferenceColorValues />": CSS_ReferenceColorValues,
  "<CSS_ReferenceCombinators />": CSS_ReferenceCombinators,
  "<CSS_ReferenceDefaultValues />": CSS_ReferenceDefaultValues,
  "<CSS_ReferenceFunctions />": CSS_ReferenceFunctions,
  "<CSS_ReferencePseudoClasses />": CSS_ReferencePseudoClasses,
  "<CSS_ReferencePseudoElements />": CSS_ReferencePseudoElements,
  "<CSS_ReferenceSelectors />": CSS_ReferenceSelectors,
  "<CSS_ReferenceUnits />": CSS_ReferenceUnits,
  "<CSS_ReferenceWebSafeFonts />": CSS_ReferenceWebSafeFonts,
  "<CSS_RGB />": CSS_RGB,
  "<CSS_RoundedCorners />": CSS_RoundedCorners,
  "<CSS_Selectors />": CSS_Selectors,
  "<CSS_Shadows />": CSS_Shadows,
  "<CSS_Snippets />": CSS_Snippets,
  "<CSS_Specificity />": CSS_Specificity,
  "<CSS_StudyPlan />": CSS_StudyPlan,
  "<CSS_Syllabus />": CSS_Syllabus,
  "<CSS_Syntax />": CSS_Syntax,
  "<CSS_Tables />": CSS_Tables,
  "<CSS_Templates />": CSS_Templates,
  "<CSS_Text />": CSS_Text,
  "<CSS_TextEffects />": CSS_TextEffects,
  "<CSS_Tooltips />": CSS_Tooltips,
  "<CSS_Transitions />": CSS_Transitions,
  "<CSS_Units />": CSS_Units,
  "<CSS_UserInterface />": CSS_UserInterface,
  "<CSS_Variables />": CSS_Variables,
  "<CSS_WebFonts />": CSS_WebFonts,
  "<CSS_Website />": CSS_Website,
  "<CSS_WebsiteLayout />": CSS_WebsiteLayout,
  "<CSS_ZIndex />": CSS_ZIndex,
  "<Flexbox_Intro />": Flexbox_Intro,
  "<Flex_Container />": Flex_Container,
  "<Flex_Items />": Flex_Items,
  "<Flex_Responsive />": Flex_Responsive,
  "<Fonts_Google />": Fonts_Google,
  "<Fonts_Pairings />": Fonts_Pairings,
  "<Fonts_Shorthand_Property />": Fonts_Shorthand_Property,
  "<Font_Fallbacks />": Font_Fallbacks,
  "<Font_Size />": Font_Size,
  "<Font_Style />": Font_Style,
  "<Grid_ColumnsRows />": Grid_ColumnsRows,
  "<Grid_Container />": Grid_Container,
  "<Grid_Intro />": Grid_Intro,
  "<Grid_Item />": Grid_Item,
  "<Grid_Lines />": Grid_Lines,
  "<Horizontal_Navigation_Bar />": Horizontal_Navigation_Bar,
  "<Outline_Color />": Outline_Color,
  "<Outline_Offset />": Outline_Offset,
  "<Outline_Shorthand />": Outline_Shorthand,
  "<Outline_Width />": Outline_Width,
  "<Overriding_Variables />": Overriding_Variables,
  "<Radial_Gradients />": Radial_Gradients,
  "<RWD_Frameworks />": RWD_Frameworks,
  "<RWD_GridView />": RWD_GridView,
  "<RWD_Images />": RWD_Images,
  "<RWD_Intro />": RWD_Intro,
  "<RWD_MediaQueries />": RWD_MediaQueries,
  "<RWD_Templates />": RWD_Templates,
  "<RWD_Videos />": RWD_Videos,
  "<RWD_Viewport />": RWD_Viewport,
  "<SASS_Tutorial />": SASS_Tutorial,
  "<Tables_Responsive />": Tables_Responsive,
  "<Table_Alignment />": Table_Alignment,
  "<Table_Borders />": Table_Borders,
  "<Table_Size />": Table_Size,
  "<Table_Styling />": Table_Styling,
  "<Text_Alignment />": Text_Alignment,
  "<Text_Color />": Text_Color,
  "<Text_Decoration />": Text_Decoration,
  "<Text_Shadow />": Text_Shadow,
  "<Text_Spacing />": Text_Spacing,
  "<Text_Transformation />": Text_Transformation,
  "<Variables_in_Media_Queries />": Variables_in_Media_Queries,
  "<Vertical_Navigation_Bar />": Vertical_Navigation_Bar,
  "<Web_Safe_Fonts />": Web_Safe_Fonts,
};

export default AllCssComponents;
